import { render, staticRenderFns } from "./LicenseTab.vue?vue&type=template&id=2dc659ab&"
import script from "./LicenseTab.vue?vue&type=script&lang=js&"
export * from "./LicenseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports